<button (click)="onClick.emit()"
	class="toggle-password-visibility-button"
	[matTooltip]="getTooltipText()"
	type="button"
	tabindex="-1">
	<i class="icon-btn" [ngClass]="{
		'ficon-app-preview-off': passwordHidden,
		'ficon-app-preview': !passwordHidden
	}">
	</i>
</button>
